import { useState } from 'react';
import updateWorkingMax from '../../api/updateWorkingMax';
import SegmentService, { EVENTS } from '../../../../lib/segment/SegmentService';

export default function useWorkingMaxEdit(
    userId,
    exerciseId,
    workingMaxValue,
    reload
) {
    const [isOpen, setIsOpen] = useState(false);
    const [inputValue, setInputValue] = useState(null);

    const onClick = () => {
        SegmentService.track(EVENTS.ClickCTA.key, {
            sources: 'Web App',
            ctaText: 'Edit Working Max Value',
            ctaLocation: 'Last Performance'
        });
        setIsOpen(true);
    };

    const onClose = () => {
        setIsOpen(false);
    };

    const onSave = async () => {
        if (!isOpen) {
            return;
        }

        if (!inputValue) {
            setIsOpen(false);
            return;
        }

        await updateWorkingMax(userId, exerciseId, inputValue);
        setInputValue(null);
        setIsOpen(false);
        reload && reload();
        SegmentService.track(EVENTS.ClickCTA.key, {
            sources: 'Web App',
            ctaText: 'Working Max Value Updated',
            ctaLocation: 'Last Performance'
        });
    };

    const onChange = event => {
        setInputValue(event.target.value);
    };
    return { isOpen, onClose, onSave, onClick, inputValue, onChange };
}
